<div class="mysales-page">
    <!-- Header -->
    <app-generic-header
            [title]=" 'my_sales.my_sales' | translate "
            [searcher]="true"
            [divider]="false"
            (onSearch)="handleSearch($event)">
    </app-generic-header>

    <div class="cosentino-tab">
        <a [ngClass]="{'cosentino-tab-journey we': true, active: status() === 'all'}" gtm-label="sales-registered_filter_all" (click)="status.set('all'); page.set(0)">
            <div class="row slds-align-middle">
                <div class="slds-col">
                    <span>{{"my_displays.all" | translate}}</span>
                </div>
            </div>
        </a>
        <a  [ngClass]="{'cosentino-tab-journey we': true, active: status() === 'draft'}" gtm-label="sales-registered_filter_drafts" (click)="status.set('draft'); page.set(0)">
            <div class="row slds-align-middle">
                <div class="slds-col">
                    <span class="">{{"my_sales.drafts" | translate}}</span>
                </div>
            </div>
        </a>
        <a  [ngClass]="{'cosentino-tab-journey we': true, active: status() == 'requested'}" gtm-label="sales-registered_filter_requested" (click)="status.set('requested'); page.set(0)">
            <div class="row slds-align-middle">
                <div class="slds-col">
                    <span>{{"my_sales.requested" | translate}}</span>
                </div>
            </div>
        </a>
        <a  [ngClass]="{'cosentino-tab-journey we': true, active: status() === 'approved'}" gtm-label="sales-registered_filter_approved" (click)="status.set('approved'); page.set(0)">
          <div class="row slds-align-middle">
            <div class="slds-col">
                <span>{{"my_sales.approved" | translate}}</span>
            </div>
          </div>
        </a>
        <a  [ngClass]="{'cosentino-tab-journey we': true, active: status() === 'denied'}" gtm-label="sales-registered_filter_denied" (click)="status.set('denied'); page.set(0)">
            <div class="row slds-align-middle">
                <div class="slds-col">
                    <span>{{"my_sales.denied" | translate}}</span>
                </div>
            </div>
        </a>
    </div>
    <!-- Sales List -->
    <div class="mysales-page__body flex flex-col lg:flex-row py-6 px-4 lg:p-8 gap-6">
      <div class="mysales-page__list order-2 lg:order-1">
        <app-sales-list [sales]="sales" [userInfo]="userInfo" (onDelete)="handleDeleteSale()"></app-sales-list>
        <div *ngIf="hasNextPage()">
            <app-button [block]="true" (onClick)="loadNextPage()">
                {{ 'global.view_more' | translate }}
            </app-button>
        </div>

          <div *ngIf="salesLoaded && sales() && sales().length == 0" class="empty-container flex justify-center">
              <div class="text-center flex flex-col gap-4">
                  <div class="empty-title typography-title-l">{{ 'my_sales.to_register_new_sale' | translate }}</div>
                  <div *ngIf="!isFabricator()" class="typography-body-m-regular">{{ 'my_sales.myclients_modalcontactclientoverview_text1' | translate }}</div>
              </div>
              <div>
                  <div class="empty-button">
                      <app-button [primary]="true" [disabled]="false" [block]="true" [class]="'py-3 px-6'" [gtmLabel]="'button_register-new-sale'" (onClick)="navigateToRegisterSale()"
                      >{{ 'my_sales.register_a_sale' | translate }}
                      </app-button>
                  </div>
              </div>
          </div>
        <!-- app-sales-list-paginator -->
      </div>
      <div *ngIf="!isLoyalty2026Active" class="mysales-page__sidebar order-1 lg:order-2">
        <div class="w-full background-medium-02 flex flex-col">
          <div class="mysales-page__cta-block p-4">
            <app-button class="w-full" [secondary]="true" [size]="'large'" [gtmLabel]="'button_register-new-sale'" (click)="navigateToRegisterSale()">
              {{ 'my_sales.register_sale' | translate }}
            </app-button>
          </div>
          <div class="mysales-page__cta-content py-6 px-4">
            <p class="typography-title-m mt-0 mb-2">{{ 'my_sales.register_a_sale' | translate }}</p>
            <div class="flex gap-1 items-start mb-4">
              <div class="mysales-page__cta-content__icon">
                <img src="assets/svgs/medal.svg" alt="Sale Icon" class="w-6 h-6">
              </div>
              <div class="mysales-page__cta-content__text">
                <p class="typography-body-m-regular mt-0 mb-2">{{ registerSaleDescription() }}</p>
                <div class="mysales-page__cta-content__info flex gap-2 items-end">
                  <span class="mysales-page__cta-content__info__label typography-body-m-regular">{{ 'my_sales.registered_sales' | translate }}</span>
                  <span class="mysales-page__cta-content__info__value typography-body-l-medium">{{ currentSales() }}/{{ nextLevelSales() }}</span>
                </div>
              </div>
            </div>
            <div class="flex gap-1 items-start">
              <div class="mysales-page__cta-content__icon">
                <img src="assets/svgs/actios.svg" alt="Sale Icon" class="w-6 h-6">
              </div>
              <div class="mysales-page__cta-content__text">
                <p class="typography-body-m-regular mt-0 mb-2">{{ 'my_sales.register_sale_description_2' | translate }}</p>
                <div class="mysales-page__cta-content__info flex gap-2 items-end">
                  <span class="mysales-page__cta-content__info__label typography-body-m-regular">{{ 'my_sales.actios' | translate }}:</span>
                </div>
                <div class="mysales-page__cta-content__info flex gap-2 items-end">
                  <span class="mysales-page__cta-content__info__label typography-body-m-regular">{{ 'my_sales.availables' | translate }}</span>
                  <span class="mysales-page__cta-content__info__value typography-body-l-medium">{{ availableActios }}</span>
                </div>
                <div class="mysales-page__cta-content__info flex gap-2 items-end">
                  <span class="mysales-page__cta-content__info__label typography-body-m-regular">{{ 'my_sales.validating' | translate }}</span>
                  <span class="mysales-page__cta-content__info__value typography-body-l-medium">{{ validatingActios }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="isLoyalty2026Active && !isFabricator()" class="mysales-page__sidebar order-1 lg:order-2">
        <div class="w-full background-medium-02 flex flex-col">

          <div class="mysales-page__cta-content py-6 px-4">
            <p class="typography-title-m mt-0 mb-2">
              {{ title2026() | translate }}
              <span *ngIf="!isFabricator()"> {{ 'my_sales.register_sales_earn_points' | translate }}</span>
            </p>

            <div class="flex gap-1 items-start mb-4" *ngIf="!isFabricator()">
              <div class="mysales-page__cta-content__icon">
                <img src="assets/svgs/medal.svg" alt="Sale Icon" class="w-6 h-6">
              </div>
              <div class="mysales-page__cta-content__text">
                <p class="typography-body-m-regular mt-0 mb-2">{{ description2026() }}</p>
                <div class="mysales-page__cta-content__info flex gap-2 items-end">
                  <span class="mysales-page__cta-content__info__label typography-body-m-regular">{{ 'my_sales.registered_sales' | translate }}:</span>
                  <span class="mysales-page__cta-content__info__value typography-body-l-medium">{{ currentSales() }}/{{ salesTarget2026() }}</span>
                </div>
              </div>
            </div>

            <div class="flex gap-1 items-start mb-4" *ngIf="!isFabricator()">
              <div class="mysales-page__cta-content__icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M4 16.575V18.375C4 18.5417 4.06267 18.6873 4.188 18.812C4.31267 18.9373 4.45833 19 4.625 19H19.375C19.5417 19 19.6873 18.9373 19.812 18.812C19.9373 18.6873 20 18.5417 20 18.375V16.575H4ZM4.625 7.05H7.95C7.86667 6.9 7.796 6.74167 7.738 6.575C7.67933 6.40834 7.65 6.23334 7.65 6.05C7.65 5.48334 7.84167 5.00834 8.225 4.625C8.60833 4.24167 9.08333 4.05 9.65 4.05C9.98333 4.05 10.296 4.13734 10.588 4.312C10.8793 4.48734 11.1333 4.70834 11.35 4.975L11.95 5.8L12.575 4.975C12.7917 4.69167 13.046 4.46667 13.338 4.3C13.6293 4.13334 13.9417 4.05 14.275 4.05C14.8417 4.05 15.3167 4.24167 15.7 4.625C16.0833 5.00834 16.275 5.48334 16.275 6.05C16.275 6.23334 16.25 6.40834 16.2 6.575C16.15 6.74167 16.075 6.9 15.975 7.05H19.375C19.8417 7.05 20.2293 7.204 20.538 7.512C20.846 7.82067 21 8.2 21 8.65V18.375C21 18.8417 20.846 19.2293 20.538 19.538C20.2293 19.846 19.8417 20 19.375 20H4.625C4.15833 20 3.771 19.846 3.463 19.538C3.15433 19.2293 3 18.8417 3 18.375V8.65C3 8.2 3.15433 7.82067 3.463 7.512C3.771 7.204 4.15833 7.05 4.625 7.05ZM4 14.425H20V8.65C20 8.5 19.9373 8.36234 19.812 8.237C19.6873 8.11234 19.5417 8.05 19.375 8.05H13.55L15.55 10.775L14.75 11.35L11.95 7.55L9.175 11.35L8.375 10.775L10.35 8.05H4.625C4.45833 8.05 4.31267 8.11234 4.188 8.237C4.06267 8.36234 4 8.5 4 8.65V14.425ZM9.65 7.05C9.93333 7.05 10.171 6.954 10.363 6.762C10.5543 6.57067 10.65 6.33334 10.65 6.05C10.65 5.76667 10.5543 5.52934 10.363 5.338C10.171 5.146 9.93333 5.05 9.65 5.05C9.36667 5.05 9.12933 5.146 8.938 5.338C8.746 5.52934 8.65 5.76667 8.65 6.05C8.65 6.33334 8.746 6.57067 8.938 6.762C9.12933 6.954 9.36667 7.05 9.65 7.05ZM14.275 7.05C14.5583 7.05 14.796 6.954 14.988 6.762C15.1793 6.57067 15.275 6.33334 15.275 6.05C15.275 5.76667 15.1793 5.52934 14.988 5.338C14.796 5.146 14.5583 5.05 14.275 5.05C13.9917 5.05 13.754 5.146 13.562 5.338C13.3707 5.52934 13.275 5.76667 13.275 6.05C13.275 6.33334 13.3707 6.57067 13.562 6.762C13.754 6.954 13.9917 7.05 14.275 7.05Z" fill="#232323"/>
                </svg>
              </div>
              <div class="mysales-page__cta-content__text">
                <p class="typography-body-m-regular mt-0 mb-2">{{ 'benefits_kb.loyalty_2026.use_points_for_rewards' | translate }}</p>
                <div class="mysales-page__cta-content__info flex gap-2 items-end">
                  <span class="mysales-page__cta-content__info__label typography-body-m-regular">{{ 'benefits_kb.loyalty_2026.points_available' | translate }}</span>
                  <span class="mysales-page__cta-content__info__value typography-body-l-medium">{{ availableActios }}</span>
                </div>
                <div class="mysales-page__cta-content__info flex gap-2 items-end">
                  <span class="mysales-page__cta-content__info__label typography-body-m-regular">{{ 'benefits_kb.loyalty_2026.points_under_validation' | translate }}</span>
                  <span class="mysales-page__cta-content__info__value typography-body-l-medium">{{ validatingActios }}</span>
                </div>
              </div>
            </div>

            <div class="mysales-page__cta-block mb-4">
              <app-button class="w-full" [primary]="true" [size]="'large'" [showIcon]="true" [iconType]="'add'" [iconPosition]="'start'" [gtmLabel]="'button_register-new-sale'" (click)="navigateToRegisterSale()">
                {{ 'my_sales.register_sale' | translate }}
              </app-button>
            </div>

            <div class="text-center" *ngIf="!isFabricator()">
              <app-button class="w-full" [size]="'large'" [showIcon]="true" [iconType]="'arrow'" [iconPosition]="'end'" [ghost]="true" [gtmLabel]="'button_redeem-points'">
                  {{ 'benefits_kb.loyalty_2026.redeem_points' | translate }}
              </app-button>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="isLoyalty2026Active && isFabricator()" class="mysales-page__sidebar order-1 lg:order-2">
        <div class="w-full background-medium-02 flex flex-col">
          <div class="mysales-page__cta-content py-6 px-4">
            <p class="typography-title-m mt-0 mb-4">
              {{ title2026() | translate }}
            </p>
            <div class="mysales-page__cta-block">
              <app-button class="w-full" [primary]="true" [size]="'large'" [gtmLabel]="'button_register-new-sale'" (click)="navigateToRegisterSale()">
                <span class="flex items-center justify-center gap-2">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M11.5 18.5V12.5H5.5V11.5H11.5V5.5H12.5V11.5H18.5V12.5H12.5V18.5H11.5Z" style="fill: #ffffff !important"/>
                  </svg>
                  {{ 'my_sales.register_sale' | translate }}
                </span>
              </app-button>
            </div>
          </div>
        </div>
      </div>
    </div>
</div>
